import { useGetAllVendorPoListQuery, useGetPoListQuery, useGetPoListWithProcurementMutation, useGetVendorDetailsWithIdQuery } from "../services/vendor/VendorApi";
import { Select, Option, FormControl, FormLabel, FormHelperText, Autocomplete } from "@mui/joy";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import { IVendorList, PurchaseOrder } from "../utils/types";
import { useEffect, useState } from "react";

interface PoSelectionDropdownProps {
  vendorCode?: string;
  value: string;
  onChange: (event: any, newValue: any) => void;
  label?: string;
  disabled?: boolean;
  user?: string;
  isEmpSidePO?: boolean;
  isRequired?: boolean;
  procurementType?: any;
  isEditMode?: any;
  module?: any;
}

const PoSelectionDropdown: React.FC<PoSelectionDropdownProps> = ({
  vendorCode,
  value,
  onChange,
  label = "PO/Contract",
  disabled = false,
  user,
  isEmpSidePO,
  isRequired,
  procurementType,
  isEditMode,
  module,
}) => {
  const [poList, setPostList] = useState<any>([]);
  const [vendorPoList, setVendorPoList] = useState<any>([]);
  const [getProcurementTypeData, { isLoading, isSuccess, isError }] = useGetPoListWithProcurementMutation();
  // const {
  //   data: poList,
  //   error,
  //   isLoading,
  //   isFetching,
  //   isSuccess,
  //   isError,
  // } = useGetPoListQuery(vendorCode, {
  //   // Crucial: This skips the API call if vendorCode is not available
  //   // or if the component is explicitly disabled.
  //   skip: !vendorCode,
  // });

  useEffect(() => {
    var getData = async () => {
      if (procurementType) {
        const response: any = (await getProcurementTypeData({ vendorCode, procurementType })) || [];
        setPostList([...response["data"]]);
      }
    };
    getData();
  }, [procurementType]);
  const {
    data: allPoList,
    error: errorPoList,
    isLoading: isLoadingAllpoList,
    isFetching: isFetchingAllPoList,
    isSuccess: isSuccessAllPoList,
    isError: isErrorAllPoList,
  } = useGetAllVendorPoListQuery(module === "Yes" ? "MM" : "FI");

  useEffect(() => {
    if (isSuccessAllPoList) {
      const val = allPoList?.map((po) => {
        return { label: `${po.vendor_code ?? ""} ${po.username ?? ""}`, key: po.vendor_code, username: po.username, vendor_code: po.vendor_code };
      });
      setVendorPoList([...val]);
    }
  }, [allPoList]);

  useEffect(() => {
    if (isEditMode && value !== "") {
      const selectedPo = poList?.find((po) => po.ebeln === value) || null;
      onChange(null, selectedPo);
    }
  }, [isEditMode, poList]);

  // Combine all conditions that should disable the select input
  const labelToDisplay = user === "vendor" ? "PO/Contract" : "Select a Vendor";
  const isEffectivelyDisabled = disabled || isLoading;

  return (
    <FormControl required={isRequired} error={isError}>
      <FormLabel sx={{ fontWeight: "bold" }}>{labelToDisplay}</FormLabel>
      {user === "vendor" ? (
        <Select
          value={value ?? ''} // still just ebeln
          onChange={(event, newVal) => {

            const selectedPo = poList?.find((po) => po.ebeln === newVal) || null;
            onChange(event, selectedPo);
          }}
          disabled={isEffectivelyDisabled}
          indicator={<KeyboardArrowDown />}
          placeholder={isLoading ? "Loading POs..." : "Select a PO"}
        >
          {/* Default option */}
          <Option value="">{isLoading ? "Loading POs..." : "Select a PO"}</Option>

          {poList?.map((po: PurchaseOrder) => (
            <Option key={po.ebeln} value={po.ebeln}>
              {/* {`${po.ebeln} — Plant: ${po.plant} — By: ${po.created_by}`} */}
              {`${po.ebeln} — FWD To: ${po.created_by}(${po.responsible_person})`}
            </Option>
          ))}
          {isSuccess && (!poList || poList?.length === 0) && (
            <Option disabled value="">
              No POs found for this vendor.
            </Option>
          )}
        </Select>
      ) : isEmpSidePO ? (
        <Select
          value={value} // still just ebeln
          onChange={(event, newVal) => {

            const selectedPo = poList?.find((po) => po.ebeln === newVal) || null;

            onChange(event, selectedPo);
          }}
          disabled={isEffectivelyDisabled}
          indicator={<KeyboardArrowDown />}
          placeholder={isLoading ? "Loading POs..." : "Select a PO"}
        >
          {/* Default option */}
          <Option value="">{isLoading ? "Loading POs..." : "Select a PO"}</Option>

          {poList?.map((po: PurchaseOrder) => (
            <Option key={po.ebeln} value={po.ebeln}>
              {`${po.ebeln} — Plant: ${po.plant} — FWD To: ${po.created_by}`}
            </Option>
          ))}
          {isSuccess && (!poList || poList.length === 0) && (
            <Option disabled value="">
              No POs found for this vendor.
            </Option>
          )}
        </Select>
      ) : (
        <>
          <Autocomplete
            disableClearable
            multiple={false}
            value={value}
            disabled={isEffectivelyDisabled}
            placeholder={isLoadingAllpoList ? "Loading POs..." : "Select a Vendor"}
            options={isSuccessAllPoList ? vendorPoList : []}
            isOptionEqualToValue={(option: any, value) => {
              return option?.key === value;
            }}
            sx={{ width: 300 }}
            onChange={(event, newVal) => {
              console.log(newVal)
              console.log(newVal)
              onChange(event, newVal);
            }}
          />
          {/* <Autocomplete
            multiple={false}
            disabled={isEffectivelyDisabled}
            options={isSuccessAllPoList ? allPoList : []}
            isOptionEqualToValue={(option, value) => option?.vendor_code === value?.vendor_code}
            getOptionKey={(po: IVendorList) => po?.vendor_code}
            placeholder={isLoadingAllpoList ? "Loading POs..." : "Select a Vendor"}
            getOptionLabel={(po: IVendorList | null) => (po ? `${po.vendor_code ?? ""} ${po.username ?? ""}` : "")}
            value={value}
            onChange={(event, newVal) => {
              onChange(event, newVal);
            }}
            filterOptions={(options, { inputValue }) => {
              return options.filter(
                (option) => option.vendor_code?.toLowerCase().includes(inputValue.toLowerCase()) || option.username?.toLowerCase().includes(inputValue.toLowerCase())
              );
            }}
          /> */}
          {/* <Select
            value={value}
            onChange={(event, newVal) => {
              const selectedPo = allPoList?.find((po) => po?.vendor_code === newVal);
              onChange(event, selectedPo);
            }}
          >
            {isSuccessAllPoList &&
              allPoList &&
              allPoList?.map((po: IVendorList) => (
                <Option key={po?.vendor_code} value={po?.vendor_code}>
                  {`${po?.vendor_code} ${po?.username}`}
                </Option>
              ))}

            {isSuccess && (!allPoList || allPoList.length === 0) && (
              <Option disabled value="">
                No POs found for this vendor.
              </Option>
            )}
          </Select> */}
        </>
      )}

      {/* Show an error message if the API call fails */}
      {isError && <FormHelperText>Error loading POs. Please check connection and try again.</FormHelperText>}
    </FormControl>
  );
};

export default PoSelectionDropdown;
